import React from 'react';
import { ScoreDeltaDirection } from '../AssessmentIndex.types';

export const DeltaArrow = ({ direction }: { direction: ScoreDeltaDirection }) => {
  const path =
    direction === 'increase'
      ? 'M8 14V2M4 6l4-4 4 4'
      : direction === 'decrease'
      ? 'M8 2v12m-4-4 4 4 4-4'
      : 'M2 8h12m-4-4 4 4-4 4';

  return (
    <svg aria-hidden="true" height="16" viewBox="0 0 16 16" width="16">
      <path
        d={path}
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2.25"
      />
    </svg>
  );
};
